import { useState } from "react";
import Select from "react-select";
import { NavbarHelper } from "../../helpers/NavbarHelper/NavbarHelper";

const ChangePlatformDropdown = (props: Record<string, any>) => {
  const { data } = props;
  // using state to store selected option value
  const [selectedOptionState, setSelectedOptionState] = useState({
    value: "select",
    label: NavbarHelper.getDropdownTranslations("select", data),
  });

  // handeling the change, when option is selected
  // it will redirect the user to the appropriate view
  const handleChange = (selectedOption: any) => {
    setSelectedOptionState(selectedOption);
    NavbarHelper.redirectTo(selectedOption.value, data);
  };

  // list of values to populate the DropDown
  const options = [
    {
      value: "select",
      label: NavbarHelper.getDropdownTranslations("select", data),
    },
    {
      value: "asian",
      label: NavbarHelper.getDropdownTranslations("asian", data),
    },
    {
      value: "european",
      label: NavbarHelper.getDropdownTranslations("europe", data),
    },
  ];

  return (
    <div className="change-view-dropdown">
      {/* opted to use react-select as linux browser behaviour 
      made it hard to see html dropdowns in certain cases */}
      <Select
        value={selectedOptionState}
        onChange={handleChange}
        options={options}
        className="change-view"
        classNamePrefix="change-view-selected-option"
        isSearchable={false}
        unstyled
      />
    </div>
  );
};

export default ChangePlatformDropdown;
